/**
 * Languages for in-browser speech recognition.
 *
 * Web Speech API requires an explicit BCP-47 language tag — it cannot
 * auto-detect. So we ship a curated list of languages relevant to the
 * Ambedkarite Buddhist Global Network UK community: English variants, the major
 * South Asian languages of the Sangha, and a handful of widely-used global
 * languages so visiting members can record in their mother tongue.
 *
 * Pāli has no native Web Speech support; suggest Hindi (hi-IN) which
 * approximates Pāli chant pronunciation reasonably well.
 */
export const NOTES_LANGUAGES = [
  { code: "en-GB", label: "English (UK)" },
  { code: "en-US", label: "English (US)" },
  { code: "en-IN", label: "English (India)" },
  { code: "hi-IN", label: "हिन्दी · Hindi" },
  { code: "mr-IN", label: "मराठी · Marathi" },
  { code: "pa-IN", label: "ਪੰਜਾਬੀ · Punjabi" },
  { code: "gu-IN", label: "ગુજરાતી · Gujarati" },
  { code: "bn-IN", label: "বাংলা · Bengali (India)" },
  { code: "bn-BD", label: "বাংলা · Bengali (Bangladesh)" },
  { code: "ta-IN", label: "தமிழ் · Tamil" },
  { code: "te-IN", label: "తెలుగు · Telugu" },
  { code: "kn-IN", label: "ಕನ್ನಡ · Kannada" },
  { code: "ml-IN", label: "മലയാളം · Malayalam" },
  { code: "ur-PK", label: "اردو · Urdu" },
  { code: "ne-NP", label: "नेपाली · Nepali" },
  { code: "si-LK", label: "සිංහල · Sinhala" },
  { code: "fr-FR", label: "Français · French" },
  { code: "es-ES", label: "Español · Spanish" },
  { code: "de-DE", label: "Deutsch · German" },
  { code: "it-IT", label: "Italiano · Italian" },
  { code: "pt-PT", label: "Português · Portuguese" },
  { code: "zh-CN", label: "中文 · Chinese" },
  { code: "ja-JP", label: "日本語 · Japanese" },
  { code: "ko-KR", label: "한국어 · Korean" },
];

const STORAGE_KEY = "abs:notes:lang";

export function detectDefaultNotesLanguage() {
  // 1) honour user's previous choice
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && NOTES_LANGUAGES.find((l) => l.code === saved)) return saved;
  } catch (e) { /* ignore */ }
  // 2) match browser language exactly, then by primary subtag
  if (typeof navigator !== "undefined" && navigator.language) {
    const exact = NOTES_LANGUAGES.find((l) => l.code.toLowerCase() === navigator.language.toLowerCase());
    if (exact) return exact.code;
    const primary = navigator.language.split("-")[0].toLowerCase();
    const partial = NOTES_LANGUAGES.find((l) => l.code.toLowerCase().startsWith(primary + "-"));
    if (partial) return partial.code;
  }
  // 3) default to English (UK) — the society's home market
  return "en-GB";
}

export function persistNotesLanguage(code) {
  try { localStorage.setItem(STORAGE_KEY, code); } catch (e) { /* ignore */ }
}
